import { render, staticRenderFns } from "./HSCodeInfoPopup.vue?vue&type=template&id=388dac3b&scoped=true"
import script from "./HSCodeInfoPopup.vue?vue&type=script&lang=js"
export * from "./HSCodeInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./HSCodeInfoPopup.vue?vue&type=style&index=0&id=388dac3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388dac3b",
  null
  
)

export default component.exports